import { initMapSliderWithCitiesTabs } from "../../modules/map-slider-with-cities-tabs/index.js";
import { API } from "../../services/api/endpoints/index.js";

export async function initDoctorsOnMap() {
    await initMapSliderWithCitiesTabs({
        endpoint: API.map.getDataMapCosmetologist,
        className: "section--doctors-on-map",
    });
}

window.onload = () => {
    initDoctorsOnMap();
}